/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Participatedosworkshoponerolemodel6Inputs */

const de__field_participatedosworkshoponerolemodel6 = /** @type {(inputs: _Field_Participatedosworkshoponerolemodel6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilgenommen an OS-Workshop One Role Model`)
};

/**

* @param {_Field_Participatedosworkshoponerolemodel6Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_participatedosworkshoponerolemodel6 = /** @type {((inputs?: _Field_Participatedosworkshoponerolemodel6Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Participatedosworkshoponerolemodel6Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_participatedosworkshoponerolemodel6(inputs)
});
export { _field_participatedosworkshoponerolemodel6 as "_field_participatedOSWorkshopOneRoleModel" }